import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FacilitiesFormService } from '../../facilities-form.service';
import { ApplicationSectionKeys } from '../../../../constants/app.constants';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { GasDeviceObject } from '../../facilities-form.domain';

@Component({
  selector: 'app-gas-device',
  styleUrls: ['./gas-device.component.scss'],
  templateUrl: './gas-device.component.html',
})
export class GasDeviceComponent extends DestroyableComponent implements OnInit {
  @Input() isReadOnly: boolean = false;
  @Input() gasDeviceData: GasDeviceObject = null;
  @Input() displayDeleteButton: boolean = false;

  @Input() parentIndex: number;
  @Input() currentIndex: number = 0;

  @Output() deleteComponent = new EventEmitter<any>();

  applicationSection = ApplicationSectionKeys.technicalData.gasDevice;

  gasDeviceFG: FormGroup;

  constructor(private facilitiesFormService: FacilitiesFormService) {
    super();
  }

  ngOnInit(): void {
    this.gasDeviceFG = new FormGroup({
      deviceId: new FormControl(this.gasDeviceData?.deviceId || ''),
      facilityId: new FormControl(this.gasDeviceData?.facilityId || ''),
      customFields: new FormControl(this.gasDeviceData?.customFields || {}, Validators.required),
    });

    this.facilitiesFormService.manageGasDeviceFormData({
      component: 'gasDevice',
      formData: this.gasDeviceFG,
      index: this.currentIndex,
      parentIndex: this.parentIndex,
    });
  }
}
